import { profileName } from "@utils/enum";

export const FavouriteNoData = ({ type, message }) => {
  return (
    <div className="mt-5">
      <div className="card empty-state-card dashboard-data-update-container">
        <div className="card-body d-flex flex-column text-center justify-content-center m-auto">
          <div className="py-2">
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1656309287/intel/dashboard%202.0/illustration_addressbook_mqbd2m.svg" className="img-fluid"></img>
          </div>
          {message ? (
            <p className="mt-4">
              <b>{message}</b>
            </p>
          ) : (
            <div className="py-2 empty-state-card-text">
              <p className="m-0">Once you bookmark any {profileName[type]}, they will start appearing here</p>
              <p className="m-0"> To bookmark {profileName[type]}:</p>
              <p className="m-0">
                Go to a {profileName[type]} profile -&gt; Bookmark {profileName[type]} List
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
